// src/App.js
import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AudioPlayerProvider } from './contexts/AudioPlayerContext';
import { BackgroundProvider } from './contexts/BackgroundContext';
import SplashScreen from './components/SplashScreen'; // Add this import
import Layout from './components/Layout';
import { HomePage } from './pages/HomePage';
import PlayerPage from './pages/PlayerPage';
import { CatchupPage } from './pages/CatchupPage';
import { BlogPage } from './pages/BlogPage';
import { NewsPage } from './pages/NewsPage';
import { ContactPage } from './pages/ContactPage';
import { SchedulePage } from './pages/SchedulePage';
import useInstallPrompt from "./useInstallPrompt";
import ScrollToTop from './components/ScrollToTop';
import VideoCatchupPage from './pages/VideoCatchupPage';

import './styles/App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function App() {
  const [splashFinished, setSplashFinished] = useState(false);
  
  const {
    isInstallable,
    promptInstall,
    isMobile,
    isStandalone,
    isIOS
  } = useInstallPrompt();

  const handleSplashFinish = useCallback(() => {
    setSplashFinished(true);
  }, []);

  return (
    <>
      {/* Splash Screen - appears first, blocks everything */}
      {!splashFinished && <SplashScreen onFinish={handleSplashFinish} />}
      
      {/* ANDROID INSTALL BANNER - only shows after splash */}
      {splashFinished && isMobile && isInstallable && !isStandalone && !isIOS && (
        <div style={bannerStyle}>
          <span>Install this app for a better experience</span>
          <button onClick={promptInstall}>Install</button>
        </div>
      )}

      {/* iOS INSTALL INSTRUCTIONS - only shows after splash */}
      {splashFinished && isMobile && isIOS && !isStandalone && (
        <div style={bannerStyle}>
          <span>
            Install this app: tap <strong>Share</strong> →{" "}
            <strong>Add to Home Screen</strong>
          </span>
        </div>
      )}

      {/* Main app content - hidden until splash finishes */}
      <div style={{ visibility: splashFinished ? 'visible' : 'hidden' }}>
        <AudioPlayerProvider>
          <BackgroundProvider>
            <Router>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<HomePage />} />
                  <Route path="player" element={<PlayerPage />} />
                  <Route path="player/:stationId" element={<PlayerPage />} />
                  <Route path="player" element={<Navigate to="/player/utter-radio" replace />} />
                  <Route path="schedule" element={<SchedulePage />} />
                  <Route path="catchup/:showSlug?/:episodeSlug?" element={<CatchupPage />} />
                  <Route path="catchup" element={<CatchupPage />} />
                  <Route path="podcasts/:showSlug/:episodeSlug" element={<VideoCatchupPage />} />
                  <Route path="podcasts/:showSlug" element={<VideoCatchupPage />} />
                  <Route path="podcasts" element={<VideoCatchupPage />} />
                  <Route path="blogs" element={<BlogPage />} />
                  <Route path="news" element={<NewsPage />} />
                  <Route path="news/:slug" element={<NewsPage />} />
                  <Route path="blogs/:slug" element={<BlogPage />} />
                  <Route path="contact" element={<ContactPage />} />
                  <Route path="apply" element={<Navigate to="/contact" replace />} />
                </Route>
              </Routes>
            </Router>
          </BackgroundProvider>
        </AudioPlayerProvider>
      </div>
    </>
  );
}

const bannerStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: '#111',
  color: '#fff',
  padding: '12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  zIndex: 1000
};

export default App;